import React from 'react'

const Contact = () => {
  return (
    <section>
      <div className="w3-center w3-padding-64" id="contact">
      <span className="w3-xlarge w3-bottombar w3-border-dark-grey w3-padding-16">
        Contact Us
      </span>
    </div>
    </section>
  )
}

export default Contact